<template>
<tr class="isInRcpAvg" :data-id="state.id">
    <td class="state_name" v-html="state.name"></td>
    <!--<td class="deaths_previous_day" v-if="wide" v-html="number_format_wrapper_plus(state.deaths_previous_day)"></td>-->
    <td v-html="number_format_wrapper(state.deaths_pm)"></td>
    <td v-if="wide" >-</td><!-- Total Cases -->
    <td v-if="!wide && !isIframe" >-</td><!-- Total Cases -->
    <td v-if="!wide && isIframe" v-html="number_format_wrapper_plus(state.new_deaths)"></td>
    <td v-html="number_format_wrapper_total(state.confirmed)"></td>
    <td v-if="wide" v-html="number_format(state.deaths_p_cases, 2)+'%'"></td>
    <td v-if="wide" >-</td><!-- Total Case Fatality Rate -->
    <td v-if="!wide" class="deaths_p_cases above_phone_portrait" v-html="number_format(state.deaths_p_cases, 2)+'%'"></td>
    <!---<td class="actual_fatality_rate above_phone_portrait">-</td>-->
    <!--<td v-html="number_format_wrapper_plus(state.new_deaths)"></td>-->
    <td v-html="number_format_wrapper_total(state.tests)"></td>
    <td v-html="number_format_wrapper(state.tests_pm)"></td>
    <!--<td class="critical" v-html="number_format_wrapper_total(state.critical)"></td>-->
    <!--<td v-if="wide" v-html="number_format_wrapper(state.critical_pm)"></td>-->
    <!--<td v-if="!wide" class="estimated_cases above_phone_portrait">-</td>-->
    <!--<td class="above_phone_portrait estimated_cases">-</td>-->
    <td v-if="wide" class="confirmed-pm" v-html="number_format_wrapper(state.confirmed_pm)"></td>
    <!--<td class="number-format-wrapper-total" v-html="number_format_wrapper_total(state.h1n1)"></td>-->
    <td v-if="!wide && !isIframe" class="total-fatality-rate" >-</td><!-- Total Case Fatality Rate -->
    <td v-if="!wide" class="deaths_p_cases phone_portrait" v-html="number_format(state.deaths_p_cases, 2)+'%'"></td>
    <td v-if="wide" class="new-deaths" v-html="number_format_wrapper_plus(state.new_deaths)"></td>
    <td class="deaths" v-html="number_format_wrapper_total(state.deaths)"></td>
    <!--<td v-if="!wide" class="influenza_deaths_v2 above_phone_portrait" v-html="number_format_wrapper_total(state.influenza_deaths_v2)"></td>
    <td v-if="wide" class="influenza_deaths_v2" v-html="number_format_wrapper_total(state.influenza_deaths_v2)"></td>-->
</tr>
</template>

<script>

import CovidMixin from './CovidMixin.js';

export default {
    name: 'state-row',
    mixins: [
        CovidMixin,
    ],
    props: {
        state: {
            type: Object,
            default: () => {
                return {};
            },
        },
        wide: {
            type: Boolean,
            default: false,
        },
        isIframe: {
            type: Boolean,
            default: false,
        },
    },
    data: function() {
        return {};
    },
    created: function() {
    },
    methods: {},
}
</script>